import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface InitiativeOrderWidgetProps {
  turnOrder?: Array<{ name: string; initiative: number }>;
  currentPlayer?: string | null;
  currentIndex?: number;
}

export function InitiativeOrderWidget({ turnOrder = [], currentPlayer, currentIndex }: InitiativeOrderWidgetProps) {
  if (!turnOrder.length) return null;

  return (
    <div className="space-y-2">
      <div className="text-[10px] font-semibold uppercase tracking-widest text-muted-foreground">Initiative Order</div>
      <div className="space-y-1">
        {turnOrder.map((entry, i) => {
          const isActive = entry.name === currentPlayer || i === currentIndex;
          return (
            <div
              key={i}
              className={cn(
                "flex items-center justify-between text-sm px-3 py-1.5 rounded-lg transition-colors",
                isActive ? "bg-primary/15 text-primary font-medium border border-primary/30" : "text-muted-foreground hover:bg-muted/30",
              )}
            >
              <span className="flex items-center gap-2">
                <span className="text-xs tabular-nums w-5 text-right text-muted-foreground">{i + 1}.</span>
                <span>{entry.name}</span>
                {isActive && <Badge variant="default" className="text-[9px] h-4 px-1">Active</Badge>}
              </span>
              <span className="text-xs tabular-nums text-muted-foreground">{entry.initiative}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
